import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import { APP_CONFIG } from 'mangools-commons/dist/configs/app'
import { parse, parseCreate } from 'sources/parsers/ReportDataParser';

// Constants
const TRACKINGS_ENDPOINT = '/trackings';
const ENDPOINT = '/reports';

/**
 * Data source class handling communication with API for reports data.
 */
class ReportSource {
    static getData({ accessToken, trackingId }) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${TRACKINGS_ENDPOINT}/${trackingId}${ENDPOINT}`;
        const headers = {
            'X-Access-Token': accessToken,
        };

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers,
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parse(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }

    static create({ accessToken, trackingId }, { alertTriggers, emails, name, type }) {
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${TRACKINGS_ENDPOINT}/${trackingId}${ENDPOINT}`;

        // Generate body data
        const requestBody = {
            emails,
            name,
            triggers: alertTriggers,
            type,
        };

        return fetch(requestURL, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X-Access-Token': accessToken,
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parseCreate(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }

    static update({ accessToken, trackingId, reportId }, { alertTriggers, emails, name, type }) {
        /* eslint-disable max-len */
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${TRACKINGS_ENDPOINT}/${trackingId}${ENDPOINT}/${reportId}`;
        /* eslint-enable max-len */

        // Generate body data
        const requestBody = {
            emails,
            name,
            triggers: alertTriggers,
            type,
        };

        return fetch(requestURL, {
            method: 'PUT',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X-Access-Token': accessToken,
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => {
                if (response.ok) {
                    return {
                        error: false,
                        payload: null,
                    };
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }

    static delete({ accessToken, trackingId, reportId }) {
        /* eslint-disable max-len */
        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${TRACKINGS_ENDPOINT}/${trackingId}${ENDPOINT}/${reportId}`;
        /* eslint-enable max-len */

        return fetch(requestURL, {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken,
            },
        })
            .then(response => {
                if (response.ok) {
                    return {
                        error: false,
                        payload: null,
                    };
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default ReportSource;
